import { useCallback } from 'react';

export const useScrollIntoView = () => {
  const scrollIntoView = useCallback((sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return scrollIntoView;
};
